import React, { useState } from 'react'
import StatusBadge from '../../../../../common/StatusBadge';
import CustomDataGrid from '../../../../../common/CustomDataGrid';
import useApprovalRequests from '../../../../../store/ReactQueries/procurements/approvalRequests/useApprovalRequests';
import { GridColDef } from '@mui/x-data-grid';
import { PAGESIZE } from '../../../../../utils/constants';
import { FieldErrors } from '../../../../../domain/helpers/Errors';
import { formatDate } from '../../../../../common/GlobalFunctions';
import { useLanguageStore } from '../../../../../store/useLanguageStore';
import { ApprovalStatus, getApprovalStatusInfo } from '../../../../../enums/approvalStatus';
import { ApprovalRequestInterface } from '../../../../../models/ProcurementModule/ApprovalRequest';

export const PendingRequests = ({ }) => {
    const { language } = useLanguageStore();
    const { data: approvalRequests } = useApprovalRequests();

    const [page, setPage] = useState<number>(1);
    const [pageSize, setPageSize] = useState<number>(PAGESIZE);
    const [errors, setErrors] = useState<FieldErrors>({});
    const initialValue: ApprovalRequestInterface = {
        id: '',
        purchaseOrderId: '',
        approvalPersonId: '',
        status: ApprovalStatus.NotStarted,
        order: 1
    };
    const [form, setForm] = useState<ApprovalRequestInterface>(initialValue);
    const [modal, setModal] = useState<{ add: boolean, edit: boolean, view: boolean }>({
        add: false,
        edit: false,
        view: false
    });

    const addItems = () => {
        setForm(initialValue);
        setModal({ ...modal, add: true });
        setErrors({});
    }

    const columns: GridColDef[] = [
        { field: 'id', headerName: 'Id', type: "string", editable: false, width: 150 },
        {
            field: 'purchaseOrder',
            headerName: 'PurchaseOrder',
            type: "string",
            editable: true,
            width: 200,
            renderCell: ({ row }) => <span>{row.purchaseOrder ? row.purchaseOrder.code : ""}</span>
        },
        {
            field: 'status',
            headerName: 'Status',
            type: "string",
            editable: true,
            width: 200,
            cellClassName: 'd-flex align-items-center',
            renderCell: ({ row }) => {
                const { color, name } = getApprovalStatusInfo(row.status as ApprovalStatus);
                return <StatusBadge name={name} color={color} width={'fit-content'} fontSize={12} />
            },
        },
        { field: 'order', headerName: 'Order', type: "string", editable: true, width: 100 },
        {
            field: 'vendor',
            headerName: 'Vendor',
            type: "string",
            editable: true,
            width: 200,
            renderCell: ({ row }) => (
                <span>
                    {row.purchaseOrder
                        && row.purchaseOrder.vendor
                        ? `${row.purchaseOrder.vendor.name ?? ''}` : ""}
                </span>
            ),
        },
        {
            field: 'purchaseOrderType',
            headerName: 'PurchaseOrderType',
            type: "string",
            editable: true,
            width: 200,
            renderCell: ({ row }) => (
                <span>
                    {row.purchaseOrder
                        && row.purchaseOrder.purchaseOrderType
                        ? `${row.purchaseOrder.purchaseOrderType.title ?? ''}` : ""}
                </span>
            ),
        },
        {
            field: 'author',
            headerName: 'Author',
            type: "string",
            editable: true,
            width: 200,
            renderCell: ({ row }) => (
                <span>{row.author ? `${row.author?.firstname ?? ''} ${row.author?.lastname ?? ''}` : ""}</span>
            ),
        },
        { field: 'createdDate', headerName: 'CreatedDate', type: "dateTime", editable: false, width: 150, valueFormatter: formatDate },
        { field: 'updatedDate', headerName: 'UpdatedDate', type: "dateTime", editable: false, width: 150, valueFormatter: formatDate },
        { field: 'authorId', headerName: 'AuthorId', type: "string", editable: false, width: 150 },
        { field: 'modifiedById', headerName: 'ModifiedById', type: "string", editable: false, width: 150 },
        { field: 'purchaseOrderId', headerName: 'PurchaseOrder', type: "string", editable: true, width: 200 },
        { field: 'approvalPersonId', headerName: 'ApprovalPerson', type: "string", editable: true, width: 200 },
    ];

    return (
        <CustomDataGrid
            name={language['PendingRequests']}
            rows={approvalRequests || []}
            showColumnModal={['title', 'isDefault']}
            hideColumns={['id', 'createdDate', 'updatedDate', 'authorId', 'modifiedById', 'purchaseOrderId', 'approvalPersonId']}
            form={form}
            page={page}
            modal={modal}
            errors={errors}
            columns={columns}
            loading={false}
            pageSize={pageSize}
            setForm={setForm}
            setPage={setPage}
            setModal={setModal}
            addItems={addItems}
            setErrors={setErrors}
            setPageSize={setPageSize}
            handleSave={function (): Promise<void> {
                throw new Error('Function not implemented.');
            }}
            newAddComponent="PendingRequests"
        />
    );
}
export default PendingRequests